import { render, staticRenderFns } from "./WhiteButton.vue?vue&type=template&id=5207f4ca&scoped=true&"
import script from "./WhiteButton.vue?vue&type=script&lang=js&"
export * from "./WhiteButton.vue?vue&type=script&lang=js&"
import style0 from "./WhiteButton.vue?vue&type=style&index=0&id=5207f4ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207f4ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5207f4ca', component.options)
    } else {
      api.reload('5207f4ca', component.options)
    }
    module.hot.accept("./WhiteButton.vue?vue&type=template&id=5207f4ca&scoped=true&", function () {
      api.rerender('5207f4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/Buttons/WhiteButton.vue"
export default component.exports